export default __webpack_public_path__ + "static/media/gif.ee8fffb9.svg";